/* eslint-disable */
import React from "react";

export const PathContext = React.createContext({
  path: "",
  changePath: (value: string) => { }
});
/* eslint-disable */
